module.exports = __webpack_public_path__ + "static/Home-50276c94b8f2f6fd3451a2a91d3bb05e.png";